import styled, { css } from 'styled-components';
/**
 * Card button wrapper
 */
export const cardButtonWrapperContainerStyles = ({ $alignment, }) => css `
	width: 100%;
	text-align: ${$alignment === 'center' ? 'center' : $alignment};
`;
export const CardButtonWrapperContainer = styled.div `
	${cardButtonWrapperContainerStyles}
`;
//# sourceMappingURL=card-button-wrapper.styled.js.map